import { get } from "../libs/https";
const publicPath = process.env.BASE_URL;

export const getAccountSettings = async () => {
    return await get(`${publicPath}api/settings/account`);
};
